import React, { useRef } from "react";
import { Box } from "@mui/system";
import { Slider, Typography } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import {
  getPlayerState,
  setMinimizePlayer,
  setPlayAll,
  setPlaying,
} from "../../../redux/features/playerSlice";
import Player from "../Player";
import RightLeftChecker from "../../../utils/RightLeftChecker";
import CustomAvatar from "../CustomAvatar";
import { isMobile } from "react-device-detect";
import CustomCircleButton from "../CustomCircleButton";

const MinimizePlayer = () => {
  const {
    playing,
    playedPercent,
    minimizePlayer,
    topicData,
    minimizePlayerBackUrl,
  } = useSelector(getPlayerState);
  const dispatch = useDispatch();
  const ref = useRef(null);
  const navigate = useNavigate();

  const handlePlay = (e) => {
    e.stopPropagation();
    dispatch(setPlaying(!playing));
  };

  const handleCloseMinimizePlayer = (e) => {
    e.stopPropagation();
    dispatch(setMinimizePlayer(false));
    dispatch(setPlaying(false));
    dispatch(setPlayAll(false));
  };

  return (
    <Box
      onClick={() => navigate(minimizePlayerBackUrl)}
      sx={{
        border: "2px solid",
        borderColor: "black.main",
        borderRadius: "16px 16px 0 0",
        minHeight: "80px",
        display: ` ${minimizePlayer ? "flex" : "none"}`,
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        width: "100%",
        backgroundColor: "white.main",
        padding: "8px",
        cursor: "pointer",
        zIndex: 5,
      }}
    >
      <Box sx={{ display: "none" }}>
        {minimizePlayer && <Player ref={ref} />}
      </Box>

      <Box
        sx={{
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Box sx={{ mr: "8px" }}>
          <CustomAvatar
            src={topicData?.author.avatar}
            size={64}
            iconType={playing ? "pause" : "video"}
            iconSize={22}
            round={"8px"}
            alt={topicData?.author.nickname}
            video
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "72%",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "12px",
              fontWeight: "400",
              lineHeight: "16px",
              color: "mute.main",
              maxWidth: "210px",
              mt: "2px",
            }}
          >
            {topicData?.author.nickname}
          </Typography>
          <Typography
            noWrap
            sx={{
              fontFamily: "Tahrir",
              fontSize: "24px",
              fontWeight: "700",
              lineHeight: "24px",
              textAlign: "left",
              mt: "2px",
              mr: "22px",
              direction: RightLeftChecker(topicData?.title) ? "rtl" : "ltr",
            }}
          >
            {topicData?.title}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              maxWidth: "100px",
              mb: "2px",
              mt: "auto",
            }}
          >
            <Slider
              aria-label='timeline'
              min={0}
              max={1}
              step={0.001}
              value={playedPercent}
              sx={{
                position: "absolute",
                padding: "0 !IMPORTANT",
                width: "100px",
                color: "primary.main",
                cursor: "default",
                "& .MuiSlider-track": {
                  border: "none",
                },
                "& .MuiSlider-thumb": {
                  display: "none",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "blackDisabled.main",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ minWidth: "90px", ml: "8px" }}>
        <CustomCircleButton
          onClick={handlePlay}
          width='40px'
          height='40px'
          bgColor='white.main'
          color='black.main'
          bShadow='none'
          border='2px solid'
          hoverBgColor='white.main'
          hoverColor='black.main'
          hoverBorder={isMobile ? "2px solid" : "none"}
          activeBgColor='black.main'
          activeColor='white.main'
        >
          {playing ? (
            <PauseRoundedIcon sx={{ fontSize: "24px" }} />
          ) : (
            <PlayArrowRoundedIcon sx={{ fontSize: "26px" }} />
          )}
        </CustomCircleButton>
        <Box sx={{ ml: "8px", display: "inline-block" }}>
          <CustomCircleButton
            onClick={handleCloseMinimizePlayer}
            width='40px'
            height='40px'
            bgColor='transparent'
            color='mute.main'
            bShadow='none'
            border='0px'
            hoverBgColor='transparent'
            hoverBorder='none'
            activeBgColor='none'
            activeColor='black.main'
          >
            <CloseRoundedIcon sx={{ fontSize: "24px" }} />
          </CustomCircleButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MinimizePlayer;
